
const PREVIOUS_AUTH_FAILED_URL = 'PREVIOUS_AUTH_FAILED_URL';
const SKIP_EXACT_ROUTES = [
  '/login'
];

export const getAndClearPreviousUrl = () => {
  console.log('getAndClearPreviousUrl');
  const item = window.localStorage.getItem(PREVIOUS_AUTH_FAILED_URL);

  console.log('item', item);
  if(!item) return null;

  window.localStorage.removeItem(PREVIOUS_AUTH_FAILED_URL);
  return item;
}

export const storePreviousUrlForRedirection = (url) => {
  if(!url || SKIP_EXACT_ROUTES.some(route => url.startsWith(route))) {
    console.log('storePreviousUrlForRedirection - SKIP');
    return;
  }

  window.localStorage.setItem(PREVIOUS_AUTH_FAILED_URL, url);
}